import { FC, useMemo } from "react";
import styled from "styled-components";

import { useSelectItemsTranslate } from "@ryde/redux";
import {
  ComplaintStatusEnum,
  DATA_E2E_KEY,
  IStyledAttributes,
  NO_VALUE_DISPLAY,
  useIsMobile,
} from "@ryde/shared";

import {
  IStatusIndicatorComplaint,
  IStatusIndicatorComplaintControl,
  StatusIndicatorComplaintConst,
} from "./status.indicator.complaint.models";

export const StatusIndicatorComplaintStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "status-indicator-complaint",
  },
)<IStatusIndicatorComplaintControl>`
  margin-inline-start: auto;
  color: ${props => props.$leftColor};
  font-size: ${props => props.fontSize || "14px"};
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const RoundDivComplaint = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "round-div-complaint",
})`
  width: 8px;
  height: 8px;
  border-radius: 4px;
`;

export const StatusIndicatorComplaint: FC<IStatusIndicatorComplaint> = ({
  status,
  fontSize,
}) => {
  const info = StatusIndicatorComplaintConst[status || ComplaintStatusEnum.New];
  const { translateLabel } = useSelectItemsTranslate();
  const { isMobile } = useIsMobile();
  const statusText = useMemo(() => {
    if (!status || !info?.$translateKey) {
      return NO_VALUE_DISPLAY;
    }

    const text = translateLabel(info.$translateKey) || "";

    if (!isMobile) {
      return text;
    }

    return text.at(0) || "";
  }, [info?.$translateKey, isMobile, status, translateLabel]);

  return (
    <StatusIndicatorComplaintStyled {...info} fontSize={fontSize}>
      <RoundDivComplaint />
      {statusText}
    </StatusIndicatorComplaintStyled>
  );
};
